export default __webpack_public_path__ + "static/media/anthe-results-mobile-banner.94213ccf.webp";